module.exports = __webpack_public_path__ + "media/images/front/icon_trophy_bronze-214609bf5572ed7eec0a2f5e8a6371f3.png";